<template>
    <span :class="getStatusClass(status)">{{getStatus(status)}}</span>
</template>
<script>
export default {
    name: "PaperStatus",
    props: ["status"],
    methods: {
        getStatus(status) {
            switch (status) {
                case "WAITING_FOR_APPROVAL":
                    return "In Evaluation";
                case "WAITING_FOR_COSPEAKER":
                    return "Waiting for Co-speaker";
                case "COSPEAKER_REFUSED":
                    return "Co-speaker Refused";
                case "APPROVED":
                    return "Approved";
                case "DRAFT":
                    return "Draft";
                case "NOT_APPROVED":
                    return "Not Approved";
                case "EXPIRED":
                    return "Expired";
            }
        },
        getStatusClass(status) {
            switch (status) {
                case "WAITING_FOR_APPROVAL":
                    return "in-evaluation";
                case "WAITING_FOR_COSPEAKER":
                    return "waiting-cospeaker";
                case "COSPEAKER_REFUSED":
                    return "cospeaker-rejected";
                case "APPROVED":
                    return "approved";
                case "DRAFT":
                    return "draft";
                case "NOT_APPROVED":
                    return "not-approved";
                case "EXPIRED":
                    return "expired";
            }
        }
    }
};
</script>
<style lang="scss" scoped>
span {
    color: white;
    padding: 3px 8px;
    font-size: 12px;
    border-radius: 4px;
    font-weight: 600;
}
.in-evaluation {
    background: #e19626;
}
.waiting-cospeaker {
    color: darkgray;
    border: 1px solid darkgray;
}
.cospeaker-rejected {
    color: #d0021b;
    border: 1px solid #d0021b;
}
.approved {
    background: #087505;
}
.draft {
    color: darkgray;
    border: 1px dashed darkgray;
}
.not-approved {
    background: #d0021b;
}
.expired {
    background: darkgray;
}
</style>